import { createModel } from "~~/package/utils/ModelUtil";
import Model from "~~/package/mapper/Model";
import {
  ProSkillManagerCandidateStatusType
} from "~~/package/mapper/proSkillManager/model/candidate/ProSkillManagerCandidateStatusType";
import {
  ProSkillManagerActionUserInfoModel
} from '~~/package/mapper/proSkillManager/model/actions/ProSkillManagerActionUserInfoModel';

export class ProSkillManagerTimelineModel extends Model {
  constructor(
    public userInfo: ProSkillManagerActionUserInfoModel = new ProSkillManagerActionUserInfoModel(),
    public statusHistoryVOList: ProSkillManagerHistory[] = [],
    public isSampleData: boolean = false
  ) {
    super();
  }

  public static create(model: Partial<ProSkillManagerTimelineModel>): ProSkillManagerTimelineModel {
    return createModel<ProSkillManagerTimelineModel>(ProSkillManagerTimelineModel, {
      ...model
    });
  }
}

class ProSkillManagerHistory {
  constructor(
    public status: ProSkillManagerCandidateStatusType = ProSkillManagerCandidateStatusType.READY,
    public statusAt: string|null = null
  ) {
  }
}
